import React, { useContext, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getMappedValueFromOrderOrItem } from '../../../../../../../../../../util';
import {
  Checkbox,
  CheckBoxColumn,
  CheckboxItem,
  NoCheckboxPlaceholder,
  QuantityText,
  ResultRowItems,
  ResultRowReturnItems,
  ResultsColumn,
  ResultsColumnGrey,
  SelectItemsText,
} from '../../DTOrderSearchResult.styles';
import Price from '../../../../../../../../../common/Price/Price';
import {
  getLineItemsOfSelectedOrder,
  getOrderingSystem,
  getSelectedLineItemsIds,
  getStatusOfItemsOfSelectedOrderByItemId,
} from '../../../../../../../../../../selectors/tools';
import { CurrencyCodeContext } from '../../CurrencyCodeContext';
import { OrderItemsSettingsContext } from '../OrderItemsSettingsContext';
import { setSelectedAllItems } from '../../../../../../../../../../actions/tools/OrdersSearchActions';
import { getDecisionNodeAtPath } from '../../../../../../../../../../extractFromState';
import ItemQuantity from './ItemQuantity/ItemQuantity';

const LineItems = (props) => {
  const dispatch = useDispatch();
  const { handleItemCheckboxClick } = props;
  const lineItems = useSelector(getLineItemsOfSelectedOrder);
  const selectedLineItemsIds = useSelector(getSelectedLineItemsIds);
  const orderingSystem = useSelector(getOrderingSystem);
  const itemStatuses = useSelector(getStatusOfItemsOfSelectedOrderByItemId);
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const currencyCode = useContext(CurrencyCodeContext);

  const orderItemsSettings = useContext(OrderItemsSettingsContext);
  const hideItemCheckbox = Boolean(orderItemsSettings && orderItemsSettings.hideItemCheckbox);

  const itemIds = useMemo(
    () => lineItems.map((item) => getMappedValueFromOrderOrItem(item, 'itemId', orderingSystem)),
    [lineItems, orderingSystem]
  );
  const isAllItemsSelected = itemIds.every((itemId) => selectedLineItemsIds.includes(String(itemId)));

  const handleSelectAllItems = () => {
    if (isAllItemsSelected) {
      return dispatch(setSelectedAllItems([]));
    }

    dispatch(setSelectedAllItems(itemIds));
  };

  return (
    <>
      {!hideItemCheckbox && !isEmpty(lineItems) && (
        <ResultRowReturnItems>
          <CheckBoxColumn>
            <Checkbox type="checkbox" id="selectAll" onChange={handleSelectAllItems} checked={isAllItemsSelected} />
            <SelectItemsText htmlFor="selectAll">Select all items ({lineItems.length})</SelectItemsText>
          </CheckBoxColumn>
          {decisionNode?.editItemCount && <QuantityText>Quantity:</QuantityText>}
        </ResultRowReturnItems>
      )}
      {lineItems.map((item, key) => {
        const itemId = getMappedValueFromOrderOrItem(item, 'itemId', orderingSystem);
        const quantityInt = parseInt(getMappedValueFromOrderOrItem(item, 'quantity', orderingSystem));
        const quantity = quantityInt ? `${quantityInt}x` : '';
        const points = getMappedValueFromOrderOrItem(item, 'points', orderingSystem);
        const price = getMappedValueFromOrderOrItem(item, 'price', orderingSystem);
        const name = getMappedValueFromOrderOrItem(item, 'name', orderingSystem);
        const sku = getMappedValueFromOrderOrItem(item, 'sku', orderingSystem);
        const isChecked = selectedLineItemsIds.includes(String(itemId));
        const showSkuAndStatus = !['custom_rbi', 'salesforce'].includes(String(orderingSystem));

        const checkbox = hideItemCheckbox ? (
          <NoCheckboxPlaceholder />
        ) : (
          <CheckboxItem type="checkbox" onChange={(e) => handleItemCheckboxClick(e, itemId)} checked={isChecked} />
        );

        return (
          <ResultRowItems key={key}>
            <CheckBoxColumn>{checkbox}</CheckBoxColumn>
            <ResultsColumn>
              {quantity} {name}
            </ResultsColumn>
            {showSkuAndStatus && (
              <>
                <ResultsColumnGrey>{sku}</ResultsColumnGrey>
                <ResultsColumnGrey>{itemStatuses[itemId]}</ResultsColumnGrey>
              </>
            )}
            <ResultsColumnGrey>
              <Price value={price} currencyCode={currencyCode} />
              {points && ` - ${points} Loyalty Points`}
            </ResultsColumnGrey>
            {decisionNode?.editItemCount && (
              <ItemQuantity itemId={itemId} itemQuantity={quantityInt} isDisabled={!isChecked} />
            )}
          </ResultRowItems>
        );
      })}
    </>
  );
};
export default LineItems;
